/* AURA — seit 25.09. nur noch zwei Griffe.
 *
 *   ZEIGER    ENTFERNT. Der eigene Mauszeiger (Punkt + Ring, cursor:none)
 *             hat dazu geführt, dass man die Maus zeitweise nicht mehr
 *             gesehen hat. Der echte Zeiger des Systems bleibt immer.
 *   MAGNETIK  ENTFERNT. Knöpfe, die dem Zeiger entgegenrutschen, sind
 *             hübsch — aber ein Ziel, das sich bewegt, ist schwerer zu
 *             treffen. „Idiotensicher" geht vor.
 *   AUFBAU    bleibt: Überschriften der älteren Blöcke buchstabenweise.
 *   KLANG     bleibt: AUS, bis jemand ihn im Fußbereich einschaltet.
 */
(function () {
  "use strict";

  var RUHIG = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Falls eine ältere, zwischengespeicherte Fassung den Zeiger schon
     gesetzt hat: aufräumen. */
  document.documentElement.classList.remove("hoa-zeiger-an", "hoa-zeiger-sichtbar");
  [].forEach.call(document.querySelectorAll(".hoa-zeiger__punkt, .hoa-zeiger__ring"),
    function (el) { el.remove(); });

  /* ============================================================ AUFBAU */
  if (!RUHIG) (function () {
    var ziele = [].slice.call(
      document.querySelectorAll("[data-aufbau], .hoa-titel"))
      .filter(function (el) { return !el.querySelector("br, img, svg"); });
    if (!ziele.length || !window.IntersectionObserver) return;

    ziele.forEach(function (el) {
      var text = el.textContent.trim();
      if (!text || text.length > 60) return;
      el.setAttribute("aria-label", text);
      var neu = "";
      for (var i = 0; i < text.length; i++) {
        var c = text[i];
        neu += c === " "
          ? " "
          : '<span class="hoa-buchstabe" style="--i:' + i + '" aria-hidden="true">'
            + c.replace(/&/g, "&amp;").replace(/</g, "&lt;") + "</span>";
      }
      el.innerHTML = neu;
      el.classList.add("hoa-aufbau");
    });

    var w = new IntersectionObserver(function (e) {
      e.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add("hoa-aufbau--da"); w.unobserve(x.target); }
      });
    }, { threshold: 0.3 });
    ziele.forEach(function (el) { if (el.classList.contains("hoa-aufbau")) w.observe(el); });
  })();

  /* ============================================================= KLANG */
  (function () {
    var SCHLUESSEL = "hoa-klang";
    var an = false;
    try { an = localStorage.getItem(SCHLUESSEL) === "1"; } catch (e) {}

    var werk = null;
    function anschlag(hoehe, laut) {
      if (!an) return;
      try {
        if (!werk) werk = new (window.AudioContext || window.webkitAudioContext)();
        if (werk.state === "suspended") werk.resume();
        var t = werk.currentTime;
        var g = werk.createGain();
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(laut, t + 0.006);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.06);
        g.connect(werk.destination);
        [hoehe, hoehe * 2.5].forEach(function (f, i) {
          var o = werk.createOscillator();
          o.type = i ? "triangle" : "sine";
          o.frequency.setValueAtTime(f, t);
          o.connect(g); o.start(t); o.stop(t + 0.07);
        });
      } catch (e) { /* kein Ton ist besser als ein Fehler */ }
    }

    document.addEventListener("pointerdown", function (e) {
      if (e.target.closest && e.target.closest("a,button,[role=button]")) anschlag(720, 0.05);
    }, { passive: true });

    function schalter() {
      var wo = document.querySelector(".footer__content-bottom, .footer, footer");
      if (!wo) return;
      var b = document.createElement("button");
      b.type = "button";
      b.className = "hoa-klangschalter";
      b.setAttribute("aria-pressed", an ? "true" : "false");
      function beschriften() {
        b.textContent = (an ? "◉" : "◎") + "  Klang " + (an ? "an" : "aus");
        b.setAttribute("aria-label", "Klangeffekte " + (an ? "ausschalten" : "einschalten"));
      }
      beschriften();
      b.addEventListener("click", function () {
        an = !an;
        try { localStorage.setItem(SCHLUESSEL, an ? "1" : "0"); } catch (e) {}
        b.setAttribute("aria-pressed", an ? "true" : "false");
        beschriften();
        anschlag(880, 0.06);
      });
      wo.appendChild(b);
    }
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", schalter);
    else schalter();
  })();
})();
